import { useEffect, useState } from 'react';
import s from './home.module.scss'
import { endOfWeek, startOfWeek } from 'date-fns';
import { StudentAnalytics } from '@widgets/student/ui/student-analytics/student-analytics';
import { NextClassCard } from '@features/schedule/ui/next-class-card/next-class-card';
import { NotNextClassCard } from '@features/schedule/ui/not-next-class-card/not-next-class-сard';
import { Loader } from '@shared/ui/loader/loader';
import { ClassesBoard } from '@widgets/schedule/ui/classes-board/classes-board';
import { useUpcomingAppointments } from '@entities/schedule/api/useUpcomingAppointments';
import { useAllAppointments } from '@entities/schedule/api/useAllAppointments';
import { useNavigate } from 'react-router-dom';
import { Alerts } from '@widgets/student/ui/alerts/alerts';
import { AddTeacherReviewModal } from '@features/student/add-teacher-review';
import { useProfile } from '@shared/api/useProfile';
import { useActivePacks } from '@shared/api/useActivePacks';
import { TeacherMatchingProgress } from '@widgets/student/ui/teacher-matching-progress/teacher-matching-progress';
import { useApplyStudentOnboardingPrefill } from '@pages/student/onboarding/lib/useApplyStudentOnboardingPrefill';
import useMedia from 'use-media';
import { PageTemplate } from '@shared/ui/page-template';
import { MobileClassBoard } from '@widgets/schedule/ui/mobile-class-board';
import { CurrentPackageCard } from '@features/schedule/ui/current-package-card/current-package-card';

export const DashboardHome = () => {
	const navigate = useNavigate()

	const teacher_id = localStorage.getItem('teacher_id')
	const {data: profile} = useProfile()
	useApplyStudentOnboardingPrefill(profile)

	const isMobile = useMedia({maxWidth: '768px'})

	const hasAppointments = process.env?.REACT_APP_SHOW_MATCH_RESULT ? process.env?.REACT_APP_SHOW_MATCH_RESULT !== 'show' : profile?.had_appointments

	const [start_date, set_start_date] = useState();
  const [end_date, set_end_date] = useState();

	const { data: appointments, isFetched: appointmentsIsFetched } =
    useAllAppointments({
      from: start_date?.toISOString(),
      to: end_date?.toISOString(),
    }, {
			enabled: hasAppointments
		});

	const { data: upcoming, isFetched: isUpcomingFetched } = useUpcomingAppointments()
	const { data: activePacks, isFetched: isActivePacksFetched } = useActivePacks({ enabled: hasAppointments })

	const hasActivePack = isActivePacksFetched && (activePacks?.data?.length > 0)

	useEffect(() => {
		const from = startOfWeek(new Date(), {weekStartsOn: 1});
		const to = endOfWeek(new Date(), {weekStartsOn: 1})

		set_start_date(from);
		set_end_date(to);
	}, []);

	if(teacher_id){
		navigate('/teacher/' + teacher_id)
	}

	return (
		<PageTemplate fullHeight>
			<AddTeacherReviewModal />
			<Alerts/>
			{hasAppointments ? <>
				<div className={s.flex}>
					<StudentAnalytics compact={hasActivePack}/>
					{hasActivePack && <CurrentPackageCard className={s.packageCard} />}
					{isUpcomingFetched ?
						(upcoming ?
							<NextClassCard className={s.nextClassCard} compact={!isMobile && hasActivePack} {...upcoming} /> :
							<NotNextClassCard className={s.nextClassCard} />) :
							<div className={s.nextClassLoader}>
								<Loader />
							</div>
					}
				</div>
				{isMobile ? <MobileClassBoard {...{appointments, set_end_date, set_start_date, appointmentsIsFetched, start_date, end_date}} isTeacher={false}/> : 
				<ClassesBoard {...{appointments, set_end_date, set_start_date, appointmentsIsFetched, start_date, end_date}} isTeacher={false}/>}
			</> :
			<TeacherMatchingProgress profile={profile}/>
			}
		</PageTemplate>
	)
}
